// Componentes nativos
import React from "react";
import { useHistory } from "react-router-dom";

// Estilização
import "../style-ferramentas.css";

// Ícones
import { GiSteam, GiGlassShot, GiWeight } from "react-icons/gi";
import { FaBalanceScale } from "react-icons/fa";
import { DiAtom } from "react-icons/di";

// Componentes personalizados
import Header from "../../Header";

export default function HomeFerramentas() {
    // Define a navegação
    const nav = useHistory();

    // Função para navegação entre conteúdos cadastrados
    function go(page: string) {
        nav.push(`/ferramentas/${page}`);
    }

    return (
        <div className="section">
            <Header />

            <div className="content">
                <div className="container">
                    <h3>Ferramentas Numéricas Interativas</h3>

                    <div className="grid-row">
                        <div className="coluna-3 pad-r">
                            <div className="caixa-opcao" onClick={() => go("2")}>
                                <GiSteam size={40} />
                                <p>Diagramas de Pressão de Saturação</p>
                            </div>
                        </div>

                        <div className="coluna-3 pad-l pad-r">
                            <div className="caixa-opcao" onClick={() => go("1")}>
                                <GiGlassShot size={40} />
                                <p>Diagramas de Coeficiente de Atividade</p>
                            </div>
                        </div>

                        <div className="coluna-3 pad-l">
                            <div className="caixa-opcao" onClick={() => go("3")}>
                                <FaBalanceScale size={40} />
                                <p>Diagramas de Equilíbrio Líquido-Vapor</p>
                            </div>
                        </div>
                    </div>

                    <div className="grid-row reset-row">
                        <div className="coluna-3 pad-r">
                            <div className="caixa-opcao" onClick={() => go("4")}>
                                <GiWeight size={40} />
                                <p>Calcular Massa Molar</p>
                            </div>
                        </div>

                        <div className="coluna-3 pad-l pad-r">
                            <div className="caixa-opcao" onClick={() => go("5")}>
                                <DiAtom size={45} />
                                <p>Tabela Periódica Interativa</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
}